import React from 'react';
import partial from 'lodash/partial';
import truncate from 'lodash/truncate';
import { Link } from 'react-router';
import CopyLinkButton from 'common/components/copy_link_button';
import { shareLink } from 'common/utils';
import {
  REFERRAL_MONEY_DISCOUNT, REFERRAL_FEATURE_DISCOUNT, REFERRAL_TOTAL_DISCOUNT
} from 'marketing/constants';

const ReferAFriedShare = ({ user }) => {
  const link = (
    typeof window !== 'undefined'?
    `${window.location.origin}/referral/${btoa(user.email)}/?utm_source=reflink` : ''
  );
  const twitterMessage = `I love @crowdspring - the easiest way to get affordable, high-quality custom logos, print design, web design, and naming for your business. Post your own project using this link and get ${REFERRAL_MONEY_DISCOUNT} off plus a ${REFERRAL_FEATURE_DISCOUNT} for free (total value: ${REFERRAL_TOTAL_DISCOUNT}). ${link}`;

  return (
    <div className="share">
      <h3>Or just copy and share this link...</h3>
      <Link to={link} className="link" target="_blank">{ truncate(link, { length: 40 }) }</Link>
      <CopyLinkButton link={link} className="btn btn-tertiary btn-md" label="Copy link"
        hideIcon={true} />
      <div className="social-media text-center">
        Share this on:
        <button onClick={partial(shareLink, link, 'facebook')}>
          <i className="fa fa-fw fa-facebook" />
        </button>
        <button onClick={partial(shareLink, twitterMessage, 'twitter')}>
          <i className="fa fa-fw fa-twitter" />
        </button>
        <button onClick={partial(shareLink, link, 'linkedin')}>
          <i className="fa fa-fw fa-linkedin" />
        </button>
      </div>
    </div>
  );
}

export default ReferAFriedShare;



// WEBPACK FOOTER //
// ./marketing/components/refer_a_friend_share.jsx